<div style="display: flex; flex-direction: column; flex: 1; margin-bottom: 12px">
  <div style="padding-left: 4px; display: flex; flex-direction: column; flex: 1">
    <div class="aems-card" style="flex: 1">
      <p class="mds-content"><strong>Cost Details</strong></p>
      <hr class="m-b-12" />
      <div class="pure-g">
        <div class="pure-u-md-12-24 pure-u-lg-12-24 p-b-16 p-r-8">
          <div
            style="
              background-color: var(--mds_brand_appearance_neutral_weak_background-color);
              padding: 20px;
              border-radius: 4px;
              text-align: center;
              border: 1px solid var(--mds_brand_appearance_neutral_weak_border-color);
            ">
            <div style="font-size: 24px; font-weight: bold; margin-bottom: 8px">
              {{ partsManagementCostDetails.price | number: '1.2-2' }}
            </div>
            <div class="mds-neutral--weak__text-color mds-text--x-small-normal">Amount (USD)</div>
          </div>
        </div>
        <div class="pure-u-md-12-24 pure-u-lg-12-24 p-b-16 p-r-8">
          <div
            style="
              background-color: var(--mds_brand_appearance_neutral_weak_background-color);
              padding: 20px;
              border-radius: 4px;
              text-align: center;
              border: 1px solid var(--mds_brand_appearance_neutral_weak_border-color);
            ">
            <div style="font-size: 24px; font-weight: bold; margin-bottom: 8px">
              {{ partsManagementCostDetails.coreValue | number: '1.2-2' }}
            </div>
            <div class="mds-neutral--weak__text-color mds-text--x-small-normal">Core Value (USD)</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
